import React from 'react';
import { motion } from 'framer-motion';
import { Crown } from 'lucide-react';

const Podium = ({ topUsers }) => {
  if (!topUsers || topUsers.length < 3) return null;

  // Masking helper
  const maskAni = (ani) => {
    const str = String(ani);
    if (str.length <= 4) return str;
    return `${str.slice(0, 3)}****${str.slice(-4)}`;
  };

  const podiumOrder = [
    { ...topUsers[1], rank: 2, height: 'h-48', color: 'from-gray-300 to-gray-500' },
    { ...topUsers[0], rank: 1, height: 'h-64', color: 'from-yellow-300 to-yellow-600' },
    { ...topUsers[2], rank: 3, height: 'h-40', color: 'from-orange-400 to-orange-700' },
  ];

  return (
    <div className="flex justify-center items-end gap-6 md:gap-10 mt-20 mb-24 h-80 relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[150%] h-[30rem] bg-purple-600/10 blur-[100px] pointer-events-none rounded-full"></div>
      
      {podiumOrder.map((user, index) => (
        <motion.div
          key={user.rank}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.2 }}
          className="relative flex flex-col items-center"
        >
          {user.rank === 1 && (
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
              className="absolute -top-16 z-20"
            >
              <Crown className="w-14 h-14 text-yellow-400 drop-shadow-[0_0_15px_rgba(250,204,21,0.8)]" />
            </motion.div>
          )}
          
          <div className="text-center mb-4 z-10">
            <p className="text-white font-bold text-xl md:text-2xl">{maskAni(user.ani)}</p>
            <p className="text-lg md:text-xl text-purple-300 font-semibold">{user.totalPoints} pts</p>
          </div>

          <div className={`w-32 md:w-40 ${user.height} relative group`}>
            <div className={`absolute inset-0 bg-gradient-to-t ${user.color} rounded-t-3xl opacity-90 shadow-[0_0_30px_rgba(0,0,0,0.3)] group-hover:opacity-100 transition-opacity`}></div>
            <div className="absolute inset-0 bg-white/10 rounded-t-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="absolute bottom-0 w-full flex justify-center pb-6">
              <span className="text-6xl font-black text-black/20">{user.rank}</span>
            </div>
            
            {/* Top glowing edge */}
            <div className="absolute top-0 w-full h-[3px] bg-white/50 rounded-t-full"></div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default Podium;
